<script lang="ts">
    import type { SaleTags } from '@shared/types/types';
    import BenefitTag from '@tile/components/benefit-tag/BenefitTag.svelte';
    import SaleTag from '@tile/components/sale-tag/SaleTag.svelte';

    interface Props {
        variationId: string;
        saleTags?: SaleTags;
        rule?: string;
    }

    let { saleTags, variationId, rule }: Props = $props();
</script>

<div class="reptile-price__saleTags">
    <SaleTag discount={saleTags?.discount} />
    <BenefitTag {saleTags} {variationId} {rule} />
</div>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens' as tokens;
    .reptile-price {
        &__saleTags {
            display: flex;
            flex-flow: row wrap;
            align-items: center;
            gap: tokens.$oc-semantic-spacing-50;
            width: 100%;
            margin: tokens.$oc-semantic-spacing-25 0 0;
        }
    }
</style>
